"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHubSettingsState = getHubSettingsState;
exports.getFetchRequestState = getFetchRequestState;
exports.getUpdateRequestState = getUpdateRequestState;
exports.getGDPRSate = getGDPRSate;
exports.getGDPREnforcementState = getGDPREnforcementState;

function getHubSettingsState(state) {
  return state.hubSettings;
}

function getFetchRequestState(state) {
  return getHubSettingsState(state).fetchRequestState;
}

function getUpdateRequestState(state) {
  return getHubSettingsState(state).updateRequestState;
}

function getGDPRSate(state) {
  var GDPRComplianceEnabled = getHubSettingsState(state).settings.filter(function (setting) {
    return setting.key === 'GDPRComplianceEnabled';
  })[0];
  return GDPRComplianceEnabled ? JSON.parse(GDPRComplianceEnabled.value) : false;
}

function getGDPREnforcementState(state) {
  var GDPREnforcementEnabled = getHubSettingsState(state).settings.filter(function (setting) {
    return setting.key === 'GDPREnforcementEnabled';
  })[0];
  return GDPREnforcementEnabled ? JSON.parse(GDPREnforcementEnabled.value) : false;
}